import React from "react";
import { QuickSearch } from "../criteria/quick-search/QuickSearch";
import { useAccessQuickSearchCriteria } from "../criteria/quick-search/useAccessQuickSearchCriteria";
import { mapSearchCriteria, SearchType } from "../searchCriteriaMapper";
import { BypassBlock } from "./BypassBlock";
import { QuickSearchCriteriaInitializer } from "./QuickSearchCriteriaInitializer";
import { SearchButtons } from "./SearchButtons";
import {
	criteriaType,
	customizeQuickSearchType,
	notDeletableType,
	supportLinkType,
} from "../../common/types/search/search";

interface SearchHeaderProps {
	criteria: criteriaType;
	customizeQuickSearch: customizeQuickSearchType;
	supportLink?: supportLinkType;
	namespace: string;
	notDeletable?: notDeletableType;
	onSearchClick: () => void;
	onClearSearch: () => void;
}

export function SearchHeader({
	criteria,
	customizeQuickSearch,
	supportLink,
	namespace,
	notDeletable,
	onSearchClick,
	onClearSearch,
}: SearchHeaderProps) {
	const { quickSearchCriteriaLoading, quickSearchCriteria } =
		useAccessQuickSearchCriteria(criteria.quickSearchFallbackCriteria);
	const mappedCriteria = quickSearchCriteria
		? mapSearchCriteria(
				quickSearchCriteria,
				SearchType.QUICK_SEARCH,
				criteria.mapSearchCriterion,
				undefined,
				undefined,
			)
		: [];
	const noCriteriaLoaded = mappedCriteria.length === 0;

	if (noCriteriaLoaded) {
		return null;
	}

	return (
		<div className="search-types">
			<QuickSearchCriteriaInitializer
				namespace={namespace}
				criteria={criteria}
				customizeQuickSearch={customizeQuickSearch}
			/>
			<BypassBlock
				skipTo="searchResults"
				label="Skip to search results"
			/>
			<SearchButtons
				customizeQuickSearchEnabled={customizeQuickSearch.enabled}
				supportLink={supportLink}
				namespace={namespace}
				onClearSearch={onClearSearch}
			/>
			<QuickSearch
				criteria={mappedCriteria}
				notDeletable={notDeletable}
				onSearchClick={onSearchClick}
				namespace={namespace}
				onClearSearch={onClearSearch}
				loading={quickSearchCriteriaLoading}
			/>
		</div>
	);
}
